/* ----------------------------

Elon Condensed Global Nav - Condensed nav version for use on Slim Plus Header

---------------------------- */

$(document).ready(function(){
	
	var $globalNav = $('#globalNav'),
        $navToggle = $('#globalNavToggle'),
        $navClose = $('#globalNavClose'),
        isOpen = 'global-nav--open',
        isClosing = 'global-nav--closing',
        isClosed = 'global-nav--closed';
	
	
	// Add classes to html (make sure we start off with elon global nav closed)
	// and add the overlay div that will darken the rest of the page when nav is open
	//----------------------------------------------
	$('html').addClass(isClosed).removeClass(isOpen);
	
	// Add an overlay element to the header to darken the page behind the nav when open
	// ** this element will also catch clicks outside of the menu to toggle a close
	//----------------------------------------------
	$('header.site-header').prepend('<div class="global-nav--overlay"></div>');

	// Adding the id of headerArea to the header for testing
	//$('header.site-header').attr('id', 'headerArea');

	
	// Global Nav Toggles
	//----------------------------------------------
	
	// show/hide the mobile menu when toggles are clicked and assign appropriate aria labels for screen readers
	$('#globalNavToggle, #globalNavClose').on('click', function(e) {
		e.preventDefault();

		if ($('html').hasClass(isOpen)) {
			$navToggle.attr('aria-expanded', 'false');
			$navClose.attr('aria-expanded', 'false');
			$('html').removeClass(isOpen).addClass(isClosing);
			$globalNav.attr('aria-hidden', 'true');
			
			setTimeout(function() {
				$('html').addClass(isClosed).removeClass(isClosing);
			}, 400);
			
		} else {
			$navToggle.attr('aria-expanded', 'true');
			$navClose.attr('aria-expanded', 'true');
			$('html').addClass(isOpen).removeClass(isClosed);
			$globalNav.attr('aria-hidden', 'false');
		}
	});
	
	// catch clicks outside of an open nav and close the nav
	$('.global-nav--overlay').on('click', function(event) {
		if (!$(event.target).closest($globalNav).length) {
			$navToggle.click();
		}
	});
	
	// close an open nav menu on swipe right
	$globalNav.on('swiperight', function(event) {
		$navToggle.click();
	});
	
	
	// Init headroom.js for showing/hiding header on scroll
	//----------------------------------------------
	$('header.site-header--mega-nav, header.site-header--simple-nav').headroom({
		offset : 50,
		tolerance : 10
	});
	
	
	// if a screen reader jump to search link exists, on click of the jump link, auto focus the search input
	//----------------------------------------------
	
	var $jumpToSearch = $('#jumpToSearch'),
			$searchInput = $('#elonEduSearch');

	if ($jumpToSearch.length) {
		$jumpToSearch.click(function(e) {
			e.preventDefault();
			$searchInput.focus();
		});	
	}
	
	
	// if a screen reader jump to search mobile link exists, on click of the jump link, open the global nav and auto focus the search input
	//----------------------------------------------
	
	var $jumpToSearchMobile = $('#jumpToSearchMobile'),
			$searchInputMobile = $('#globalNavSearch');

	if ($jumpToSearchMobile.length) {
		$jumpToSearchMobile.click(function(e) {
			e.preventDefault();
			$('#globalNavToggle').click();
			
			setTimeout(function() {
				$searchInputMobile.focus();
			}, 500);
			
		});	
	}
	
	
	// add class to html when site mobile nav (mega and simple versions) is open to hide overflow and disable scrolling
	//----------------------------------------------
	
	$('#siteMobileNavToggle, #siteMobileSimpleNavToggle').click(function(e){
		if ($(this).hasClass('collapsed')) {
			$('html').addClass('hide-overflow');
		} else {
			$('html').removeClass('hide-overflow');
		}
	});
	
	
	// close an open site nav mobile menu on swipe up
	//----------------------------------------------
	
	// need to test this on actual touch device to see if it's too sensitive. might end up getting rid of this if it doesn't provide a good user experience.
	
	// RB NOTE: 08-17-2022 - disabling this feature. for longer mobile menus, i think this behavior is too sensitive
	// and ends up collapsing the mobile menu if a user is trying to scroll through the long menu
	
	/*
	if ($(window).width() < 1080) {
		if ( $('#siteNavContent').length || $('#siteSimpleNavContent').length ) {
			$('#siteNavContent, #siteSimpleNavContent').on('swipeup', function(event) {
				$(this).collapse('hide');
				$('html').removeClass('hide-overflow');
			});
		}
	}
	*/
	
	// Viewport Height Unit Shim for Mobile Browsers
	//----------------------------------------------
	
	// detect mobile browsers
	function isMobile() {
		return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	}
	
	// https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
	// if mobile browser, get the value of the current viewport taking the browser’s interface into account (the fixed footer nav at the bottom of safari/chrome) and reset the vh unit value based on pixels
	if ( isMobile() ) {
		
		if ( $('#siteNavContent').length || $('#siteSimpleNavContent').length ) {
			
			let vh = window.innerHeight * 0.01;
			$('#siteNavContent, #siteSimpleNavContent').find('.nav-list').attr('style', '--vh:' + vh + 'px');
			
			$(window).resize(function () {
				let vh = window.innerHeight * 0.01;
				$('#siteNavContent, #siteSimpleNavContent').find('.nav-list').attr('style', '--vh:' + vh + 'px');
			});
		}
	}

});


// header secondary nav link location depending on screen size (moves to primary nav on mobile)
$(function() {

	var mobileNavBreakpoint = 1080,
			// secondary nav variables
			secondaryNavContainer = '#siteSecondaryNav',
			$secondaryNavContainer = $(secondaryNavContainer),
			primaryNavContainer = '#siteNavContent',
			$primaryNavContainer = $(primaryNavContainer),
			secondaryNavItem = '.menu-item:not(.menu-item--primary)',
			navEl = '.nav-list';

	function moveSecondaryNav() {
		var windowWidth = $(window).width();
		
		if (windowWidth >= mobileNavBreakpoint) {
			$primaryNavContainer.find(secondaryNavItem).appendTo($(navEl, secondaryNavContainer));
		} else {
			$secondaryNavContainer.find(secondaryNavItem).appendTo($(navEl, primaryNavContainer));
		}
	}

	// Window listeners	
	$(window).resize(function(){
		moveSecondaryNav();
	});
	
	moveSecondaryNav();

});


// top bar log in link location depending on screen size (moves to primary nav on mobile)
$(function() {

	var customBreakpoint = 641,
			logInLinkContainer = '#siteHeaderLogin',
			$logInLinkContainer = $(logInLinkContainer),
			logInLink = '.login-link',
			primaryNavContainer = '#siteNavContent',
			$primaryNavContainer = $(primaryNavContainer),
			simplePrimaryNavContainer = '#siteSimpleNavContent',
			$simplePrimaryNavContainer = $(simplePrimaryNavContainer),
			navEl = '.nav-list';
	
	if ($primaryNavContainer.length) {
		var navContainer = primaryNavContainer;
	} else if ($simplePrimaryNavContainer.length) {
		var navContainer = simplePrimaryNavContainer;
	}
	
	var $navContainer = $(navContainer);

	function moveLogInLink() {
		var windowWidth = $(window).width();
		
		if (windowWidth >= customBreakpoint) {
			$navContainer.find(logInLink).unwrap().appendTo($logInLinkContainer);
		} else {
			$logInLinkContainer.find(logInLink).prependTo($(navEl, navContainer)).wrap('<li class="menu-item login-menu-item"></li>');
		}
	}

	// Window listeners	
	$(window).resize(function(){
		moveLogInLink();
	});
	
	moveLogInLink();

});